import arial from './../assets/images/Backgrounds/arial.png'

const Hero = () => {
  return (
    <div className='w-full h-[90vh] relative'>

      {/* Background Video */}
      <img
        src={arial}
        alt="Arial Background"
        className="absolute top-0 left-0 w-full h-[90vh] object-cover"
      />

      {/* Overlay */}
      <div className='bg-black/30 absolute top-0 left-0 w-full h-[90vh] z-10'/>

      {/* Content */}
      <div className='absolute top-16 w-full h-full flex flex-col justify-center text-white text-center z-20'>
        <div className='md:left-[10%] md:right-[10%] max-w-[1100px] m-auto absolute p-4'>
          <h1 className='font-bold text-5xl md:text-7xl drop-shadow-2xl'>Dine, Stay, Celebrate</h1>

          <p className='drop-shadow-2xl py-4 text-xl'>
            Experince the beautiful Staffordshire countryside. 
            Whether that's celebrating in our function room, snoozing in our rooms or dining in our restaurant 
            with real ales and unique food.
          </p>

          <div>
            <a className='mx-2' href='https://www.opentable.co.uk/r/the-fox-inn-reservations-stourbridge?restref=161223&lang=en-GB&ot_source=Restaurant%20website'>
              <button className='bg-white text-black border-2 border-black px-4 py-1 rounded-full font-bold hover:bg-black hover:text-white transition-all duration-300'>
                Book Now
              </button>
            </a>

            <a className='mx-2' href='https://www.foxinnstourtononline.com'>
              <button className='bg-white text-black border-2 border-black px-4 py-1 rounded-full font-bold hover:bg-black hover:text-white transition-all duration-300'>
                Order Delivery & Takeaway
              </button>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Hero;
